const toEmptySettings = (settingsFields) =>
  Object.fromEntries(settingsFields.map((field) => [field.name, '']));

const toStoredSettings = (settingsFields, credential) =>
  Object.fromEntries(
    settingsFields.map((field) => [field.name, credential[field.name] ?? '']),
  );

const toSecretPayload = (clientSecret) => {
  if (clientSecret === '') {
    return null;
  }
  return clientSecret;
};

export const toEmptyForm = (settingsFields, scopeOptions) => ({
  client_id: '',
  client_secret: '',
  token_url: '',
  scopes: scopeOptions ?? [],
  settings: toEmptySettings(settingsFields),
});

export const toStoredForm = (settingsFields, credential) => ({
  client_id: credential.client_id,
  client_secret: '',
  token_url: credential.token_url ?? '',
  scopes: credential.scopes,
  settings: toStoredSettings(settingsFields, credential),
});

export const toScopeOptions = (scopeOptions, storedScopes) =>
  scopeOptions.concat(
    storedScopes.filter((scope) => !scopeOptions.includes(scope)),
  );

export const toggleScope = (scopes, scope, checked) => {
  if (checked) {
    return scopes.concat(scope);
  }
  return scopes.filter((selected) => selected !== scope);
};

export const toFreeTextScopes = (value) => {
  if (value === '') {
    return [];
  }
  return [value];
};

export const toCredentialPayload = (form, showTokenUrl) => {
  const payload = Object.assign(
    {
      client_id: form.client_id,
      client_secret: toSecretPayload(form.client_secret),
      scopes: form.scopes,
    },
    form.settings,
  );
  if (showTokenUrl) {
    payload.token_url = form.token_url;
  }
  return payload;
};
